import React from "react";
import { ExpandableCard, Typography, Tag } from "@ann/web-components";
import {
  ContentWrapper,
  RowWrapper,
  ColumnWrapper,
  BodyContainer,
  InfoRow,
  InlineTagWrapper,
} from "./RepairOrdersContent.styled";

const RepairOrdersContent = ({ orders = [] }) => {
  if (!orders.length) {
    return (
      <ContentWrapper>
        <Typography category="body" weight="regular" size="medium" color="body">
          Repair order details will show up here once they’re available.
        </Typography>
      </ContentWrapper>
    );
  }

  return (
    <ContentWrapper>
      {orders.map((ro) => (
        <ExpandableCard key={ro.id}>
          <ExpandableCard.Header>
            <RowWrapper>
              {[
                { label: "Vehicle", value: ro.vehicle },
                { label: "RO Number", value: ro.roNumber },
                { label: "Mileage In", value: ro.mileageIn },
                {
                  label: "Status",
                  value: <Tag color={ro.status.color} size="small" text={ro.status.text} />,
                  isTag: true,
                },
              ].map(({ label, value, isTag }, index) => (
                <ColumnWrapper key={`${ro.id}-${label}`} className={`col-${index + 1}`}>
                  <Typography category="subtitle" weight="bold" size="small">
                    {label}
                  </Typography>
                  {isTag ? (
                    <InlineTagWrapper>{value}</InlineTagWrapper>
                  ) : (
                    <Typography category="body" weight="regular" size="medium" color="body">
                      {value}
                    </Typography>
                  )}
                </ColumnWrapper>
              ))}
            </RowWrapper>
          </ExpandableCard.Header>
          <ExpandableCard.Content>
            <BodyContainer>
              {ro.details.map((d) => (
                <InfoRow key={`${ro.id}-${d.label}`}>
                  <Typography category="body" weight="regular" size="medium">
                    {d.label}
                  </Typography>
                  <Typography category="body" weight="regular" size="medium" color="body">
                    {d.value}
                  </Typography>
                </InfoRow>
              ))}
            </BodyContainer>
          </ExpandableCard.Content>
        </ExpandableCard>
      ))}
    </ContentWrapper>
  );
};

export default RepairOrdersContent;
